import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_VELOTAX_PRO_URL || "http://localhost:8888",
  headers: {
    "ngrok-skip-browser-warning": "69420"
  }
});

export default api;
